import { User } from '../../apiTypes';
import { Lang } from '../../contexts/locale.context';

const addressBookMap: Record<Lang, string> = {
  uk: '297045',
  es: '297047',
  en: '311414',
  ru: '297045',
};

const addUserToSendPulse = async (user: User, lang: Lang) => {
  if (lang === 'en') {
    return;
  }

  try {
    const res = await fetch('https://api.sendpulse.com/oauth/access_token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        grant_type: 'client_credentials',
        client_id: '3dc67cde9eefe3c0dc5bb149397404ab',
        client_secret: '5345a578f3d0297f1b235051106854a1',
      }),
    });

    const resJson = await res.json();

    await fetch(`https://api.sendpulse.com/addressbooks/${addressBookMap[lang]}/emails`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${resJson.access_token}` },
      body: JSON.stringify({
        emails: [
          {
            email: user.email,
            variables: {
              Name: user.displayName,
              Phone: user.phone,
            },
          },
        ],
      }),
    });
  } catch (e) {
    // Sentry.captureException({ message: 'Failed adding to sendpulse', ...user });
  }
};

export default addUserToSendPulse;
